import { useCallback } from 'react';
import { useNavigate, useRouter, type LinkProps } from '@tanstack/react-router';

/**
 * Goes back in browser history when this session pushed the current entry,
 * so a detail view opened from e.g. a process returns to that process instead
 * of pushing a second copy of a hard-coded overview on top. The given route is
 * only the fallback for deep links (no in-app history).
 */
export function useHistoryBack({ to, params }: Pick<LinkProps, 'to' | 'params'>) {
  const router = useRouter();
  const navigate = useNavigate();
  return useCallback(() => {
    if (router.history.canGoBack()) {
      router.history.back();
    } else {
      navigate({ to, params });
    }
  }, [router, navigate, to, params]);
}
